module.exports = __webpack_public_path__ + "static/media/drugs.97f8c77a.svg";